import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CareTEamService } from 'src/app/services/care-team.service';
import { addresses, modelCareTeam, Results } from 'src/app/models/careteam/careteam';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReferralService } from '../../services/referral.service';
import { selectedReferrals, ReferralsRequest, Referral, referringPhysician, referralDetail, addReferral, npiSearchResponse } from 'src/app/models/referral/referral';
import { UpdateinfoService } from 'src/app/services/updateinfo.service';
import { jsPDF } from 'jspdf';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
declare var $: any;

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.css']
})
export class ReferralComponent implements OnInit {
  isreferralScreen: boolean = true;
  isSearch: boolean = false;
  referrals: any[] = [];  // To hold referrals
  insurances: any[]=[];  // To hold referrals
  getSelectedReferralInfo: selectedReferrals[] = [];
  ReferringDetails: referringPhysician = new referringPhysician();
  ReferralDetails: referralDetail = new referralDetail();
  _addReferral: addReferral = new addReferral();
  patientAccount: any
  practiceCode: any
  practiceName: any
  selectedProvider: any = '';
  selectedReferralProvider: Referral;
  already_Suggested: any = 'yes';
  bysearch: boolean = false;
  ptZip: any = '';
  ptCity: any = '';
  ptState: any = '';
  status: any;
  zipcodes: any = "8810,8828,8852,8884,8824,8816,8902,8823,8882,8850,8988,8922,8903,8905,8906,8933,8989,8901,8875,8873,8904,8855";
  isAdvancedSearch: boolean = false;
  showSpecialists: boolean = true;
  _cityandstate: any;
  isZipCodeNotValidFinancialInfo: boolean = false;
  nameNPIMissing: boolean = false;
  providerfax: any = '';
  primaryInusranceName: any = '';
  secondaryInusranceName: any = '';
  primaryInusrancepolicy: any = '';
  secondaryInusrancepolicy: any = '';
  practiceAddress: any='';
  patientPhone: any;
  speciality: any='';
  practiceFax: any;
  practicePhone: any;
  patientFname: any;
  patientLname: any;
  patientAddress: any;
  patientDOB: any;
  patientSSN: any;
  isValidFax: boolean = true;
  isFax: boolean = true;
  ShowFax: boolean = false;
  mainScreen: boolean=false;
  confirmScreen: boolean = false;
  defaultptZip:any= '';
  defaultptCity:any= '';
  defaultptState:any= '';
  
  constructor(private translateService: TranslateService, private service: CareTEamService, private spinner: NgxSpinnerService, private phrUtils: PhrutillsService, private router: Router, private referralService: ReferralService, private UpdateinfoService: UpdateinfoService) {
    let info = localStorage.getItem('referralData');
    let auth = localStorage.getItem('isAuth');
    //console.log("auth ",auth);
    if (auth=='false' || auth==null || auth==undefined) {
      let query = sessionStorage.getItem('referralLink');

      if (query == null) {
        query = '';
      }
      this.router.navigateByUrl("preferral?ref=" + query);
     // this.router.navigateByUrl('/preferral');
      return;
    }
   

  }
  referralStatus: any = 'new';
  ngOnInit(): void {
   // console.log("test");
   // this.signatureImg = 'assets/images/signature.png'

    const refData = localStorage.getItem("referralData");
    const _insurances = localStorage.getItem("insuranceData");
    const prAddress = localStorage.getItem("prAddress");
   // const prAddress = "2648 ROUTE 27, NORTH BRUNSWICK, NJ 08902-1021";
    console.log(prAddress);
    if (prAddress != null && prAddress != undefined && prAddress !="") {
      this.practiceAddress = this.formatAddress(prAddress);
      console.log(this.practiceAddress);
    }
    
    const ptPhone = localStorage.getItem("ptPhone");
    if (ptPhone != undefined && ptPhone != null) {
      this.patientPhone = this.phrUtils.decrypt(ptPhone);
      this.patientPhone = this.maskPhoneNumber(this.patientPhone);
    } else {
      this.patientPhone = "";
    }
    const ssn = localStorage.getItem("ptssn");
    if (ssn != undefined && ssn != null) {
      this.patientSSN = this.phrUtils.decrypt(ssn);
    } else {
      this.patientSSN = "";
    }
  
    const spec = localStorage.getItem("prSP");
    if (spec != undefined && spec != null) {
      this.speciality = spec;
    } else {
      this.speciality = "";
    }
    const prfax = localStorage.getItem("prfax");
    const prPhone = localStorage.getItem("prPhone");
    this.practicePhone = this.maskPhoneNumber(prPhone);
    this.practiceFax = this.maskPhoneNumber(prfax);
    const ptfname = localStorage.getItem("ptfname");
    if (ptfname != undefined && ptfname !=null) {
      this.patientFname = this.phrUtils.decrypt(ptfname);
    } else {
      this.patientFname = "";
    }
    const ptlname = localStorage.getItem("ptlname");
    if (ptlname != undefined && ptlname != null) {
      this.patientLname = this.phrUtils.decrypt(ptlname);
    } else {
      this.patientLname = "";
    }

    this.patientFname = this.toTitleCase(this.patientFname);
    this.patientLname = this.toTitleCase(this.patientLname);
    const ptdob = localStorage.getItem("ptdob")
    if (ptdob != undefined && ptdob != null) {
      this.patientDOB = this.phrUtils.decrypt(ptdob);
      this.patientDOB = this.patientDOB.split(' ')[0];
    } else {
      this.patientDOB = "";
    }
    const ptAddress = localStorage.getItem("ptAddress");
    if (ptAddress != undefined && ptAddress != null) {
      this.patientAddress = this.toTitleCase(ptAddress);
    }
    const ptzip = localStorage.getItem("zip");
    if (ptzip != undefined && ptzip != null) {
      this.defaultptZip = this.phrUtils.maskingZipNum(ptzip);
    }
    const ptcity = localStorage.getItem("city");
    if (ptcity != undefined && ptcity != null) {
      this.defaultptCity = this.toTitleCase(ptcity); ;
    }
    const ptstate = localStorage.getItem("state");
    if (ptstate != undefined && ptstate != null) {
      this.defaultptState = ptstate;
      this.ptState = this.defaultptState;
     // console.log("pt state ",this.ptState);
    }
 
    if (refData != undefined && refData != null) {
      this.referrals = this.phrUtils.decrypt(refData);
    } else {
      this.referrals = [];
    }
    if (_insurances != undefined && _insurances != null) {
      this.insurances = this.phrUtils.decrypt(_insurances);
    } else {
      this.insurances = [];
    }

    this.PrimaryandSecondaryInsurance(this.insurances);
   // console.log("referral ",this.referrals);
    this.patientAccount = localStorage.getItem("ptAccount");
    this.practiceCode = localStorage.getItem("prCode");
    this.practiceName = localStorage.getItem("prName");
    const refRequest = localStorage.getItem("refRequest");
   // console.log("referral request ",refRequest);
    const refStatus = localStorage.getItem("refStatus");
    if (refStatus != undefined && refStatus != null) {
     this.referralStatus = refStatus;
     //this.referralStatus = 'new';
      if (this.referralStatus == 'sent' || this.referralStatus == 'confirm') {
        this.mainScreen = true;
        this.confirmScreen = false;
        this.isreferralScreen = false;
        this.GetPatientSelectedReferral(this.patientAccount, this.practiceCode);
      }
    }
   // this.onFocusOutZIPFinancial(this.ptZip, 1)
    //this.GetPatientSelectedReferral(this.patientAccount, this.practiceCode);
    this.GetReferralDetails();
    if (refRequest != null && refRequest != undefined && refRequest != "") {
      this.mainScreen = false;
      this.confirmScreen = true;
      this.isreferralScreen = false;
      this._addReferral = this.phrUtils.decrypt(refRequest);
      if (this._addReferral.fax == '') {
        this.providerfax = '';
        this.ShowFax = true;
      }
      
     // console.log("from start ", this._addReferral);
    }
    this.GetSpecialityList();
    this.phrUtils.setTitle('referral');
  }

  maskPhoneNumber(phoneNo:any) {
    //mask phonenumber
    if (phoneNo == '' || phoneNo == null || phoneNo==undefined) {
      return '';
    }
    const ptPhoneNumber = phoneNo;
    const sanitizedptPhoneNumber = ptPhoneNumber.replace(/[^0-9]/g, ''); // Removes all non-numeric characters
    return this.phrUtils.maskingPhoneNumer(sanitizedptPhoneNumber)
  }
  unMaskPhoneNumber(phoneNo: any) {
    //mask phonenumber
    if (phoneNo == '' || phoneNo == null || phoneNo == undefined) {
      return '';
    }
    const ptPhoneNumber = phoneNo;
    const sanitizedptPhoneNumber = ptPhoneNumber.replace(/[^0-9]/g, ''); // Removes all non-numeric characters
    return sanitizedptPhoneNumber;
  }

  toTitleCase(name: string): string {
    return name
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  formatAddress(input: string): string {
  // Split the string by commas and whitespace
  let parts = input.split(',');

    if (parts.length >= 3) {
      let address = this.toTitleCase(parts[0].trim()); // Address in title case
      let city = this.toTitleCase(parts[1].trim()); // City in title case
      let stateZip = parts.slice(2).join(',').trim(); // State and zip unchanged

      // Return the formatted address
      return `${address}, ${city}, ${stateZip}`;
    }
    return input;
}


  isSkipfax: boolean=false;
  skipReferralFax(event: Event): void{
      // Use event.target as HTMLInputElement to access the checked property
      const checkbox = event.target as HTMLInputElement;
      const isChecked = checkbox.checked;

      if(isChecked) {
        this.isSkipfax = true;
        this.isFax = true;
        this.providerfax = "";
        console.log('Checkbox is checked. You can goto to next.');
        console.log('Checkbox is checked.', this.providerfax);
      } else {
        this.isSkipfax = false;
        console.log('Checkbox is unchecked. Fax is required.');
      }
    
  }

  PrimaryandSecondaryInsurance(res:any) {
    console.log("p and s insuarnce");
    res.forEach((insurance: any) => {
      if (insurance.prI_SEC_OTH_TYPE == "P") {
        this.primaryInusranceName = this.toTitleCase(insurance.inspayeR_DESCRIPTION);
        this.primaryInusrancepolicy = insurance.policY_NUMBER;
      //  console.log(this.primaryInusranceName);
      //  console.log(this.primaryInusrancepolicy);

      } else if (insurance.prI_SEC_OTH_TYPE == "S") {
        this.secondaryInusranceName = this.toTitleCase(insurance.inspayeR_DESCRIPTION);
        this.secondaryInusrancepolicy = insurance.policY_NUMBER;
      //  console.log(this.secondaryInusranceName);
      //  console.log(this.secondaryInusrancepolicy);
      } else {
        this.primaryInusranceName = '';
        this.secondaryInusranceName = '';
        this.primaryInusrancepolicy = '';
        this.secondaryInusrancepolicy = '';
      }
    })
  
  }

  loadImageAsBase64(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        if (ctx) {  // Ensure ctx is not null
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        } else {
          reject(new Error('Canvas context is not available.'));
        }
      };
      img.onerror = (error) => reject(error);
      img.src = url;
    });
  }

  docName: any ='Referral Letter';
  async generatePDF() {
    this.printReferralLogs(this.patientAccount, this.practiceCode);
    const imageBase64 = await this.loadImageAsBase64(this.signatureImg);   
    const diagnosis = this.ReferralDetails.diagnosis;
    if (diagnosis !== "") {
      const diagnosisList = diagnosis.split(',');

      var diagnosisText = diagnosisList.map((item: any, index: any) => {
        const parts = item.split('-');
        if (parts.length > 1) {
          return [
            { text: parts[0], bold: true }, 
            { text: '-' + parts.slice(1).join('-') }, 
            (index !== diagnosisList.length - 1) ? { text: ',' } : ''
          ];
        } else {
          return [{ text: item },
            (index !== diagnosisList.length - 1) ? { text: ',' } : ''
          ];
        }
      }).flat();
    }

    const docDefinition = {
      pageMargins: [10, 5, 10, 10], // left, top, right, bottom
      content: [
        {
          table: {
            widths: ['*'],
            body: [
              [{
                text: this.practiceName,
                fontSize: 14,
                bold: true,
                alignment: 'left',
                margin: [5, 5, 0, 0],
                fillColor: '#f1f2f6 '
              }],
              [{
                text: [
                  this.practiceAddress + '\n',
                  { text: 'Phone: ', bold: true },
                  this.practicePhone + '\n',
                  { text: 'Fax: ', bold: true },
                  this.practiceFax
                ],
                fontSize: 11,
                alignment: 'left',
                margin: [5, 0, 0, 10],
                fillColor: '#f1f2f6',
                color:'#212121'
              }]
            ]
          },
          layout: 'noBorders'
        },
        { text: 'Referral Letter', style: 'header', alignment: 'center', margin: [0, 10, 0, 0] },

        { text: 'Patient Information', style: 'subheader' },
        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 575, y2: 0, lineWidth: 1, lineColor: '#f1f2f6' }], margin: [0, 0, 0, 10] },
        this.createSection([
          { label: 'Name', value: this.patientFname + ' ' + this.patientLname },
          { label: 'Phone Number', value: this.patientPhone },
          { label: 'Primary Insurance', value: this.primaryInusranceName },
          { label: 'Secondary Insurance', value: this.secondaryInusranceName },
          { label: 'Patient Address', value: this.patientAddress + ', ' + this.defaultptCity + ', ' + this.defaultptState + ' ' + this.defaultptZip },], [
          { label: 'DOB', value: this.patientDOB },
          { label: 'SSN', value: '*****'+this.patientSSN },
          { label: 'Policy #', value: this.primaryInusrancepolicy },
          { label: 'Policy #', value: this.secondaryInusrancepolicy },
        ]),


        { text: 'Referring Physician', style: 'subheader',margin:[0, 10, 0, 5] },
        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 575, y2: 0, lineWidth: 1, lineColor: '#f1f2f6' }], margin: [0, 0, 0, 10] },
        this.createSection([
          { label: 'Name', value: this.ReferringDetails.name },
          { label: 'Phone Number', value: this.ReferringDetails.phoneNumber },
          { label: 'Address', value: this.ReferringDetails.address + ', ' + this.ReferringDetails.city + ', ' + this.ReferringDetails.state + ' ' + this.ReferringDetails.zipCode }], [
          { label: 'Specialty', value: this.ReferringDetails.speciality },
          { label: 'Fax', value: this.ReferringDetails.fax },
        ]),

        { text: 'Referred To', style: 'subheader' },
        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 575, y2: 0, lineWidth: 1, lineColor: '#f1f2f6' }], margin: [0, 0, 0, 10] },
        this.createSection([
          { label: 'Name', value: this.getSelectedReferralInfo[0].referral_FirstName + ' ' + this.getSelectedReferralInfo[0].referral_LastName },
          { label: 'Phone Number', value: this.getSelectedReferralInfo[0].phonE_NO },
          { label: 'Address', value: this.getSelectedReferralInfo[0].address + ', ' + this.getSelectedReferralInfo[0].city + ', ' + this.getSelectedReferralInfo[0].state + ' ' + this.getSelectedReferralInfo[0].zip }], [
          { label: 'Specialty', value: this.getSelectedReferralInfo[0].speciality },
          { label: 'Fax', value: this.getSelectedReferralInfo[0].faX_NO },
        ]),
        { text: 'Referral Information', style: 'subheader' },
        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 575, y2: 0, lineWidth: 1, lineColor: '#f1f2f6' }], margin: [0, 0, 0, 10] },
        this.createReasonSection([
          { label: 'Reason For Referral', value: this.ReferralDetails.reason },
         // { label: 'Diagnosis', value: this.ReferralDetails.diagnosis },
          { label: 'Diagnosis', value: diagnosisText },
        ]),
        this.createSection([
   /*       { label: 'Reason for Referral', value: this.ReferralDetails.reason },*/
          /*     { label: 'Diagnosis', value: this.ReferralDetails.diagnosis },*/
          { label: 'Referral Code', value: this.ReferralDetails.refCode },
          { label: 'Referral Start Date', value: this.ReferralDetails.refStartDate },
          { label: 'Referral Date', value: this.ReferralDetails.refDate }], [
          { label: 'Allowed Visit(s)', value: this.ReferralDetails.allowedVisits },
          { label: 'Referral End Date', value: this.ReferralDetails.refEndDate },
        ]),
        { text: '', style: 'subheader' },
        this.createFooterSection( [
          { label: 'Signed By', value: this.ReferralDetails.signedBy },
          { label: 'Signature', value: '' }
        ], imageBase64),
      ],
      styles: {
        header: {
          fontSize: 16,
          bold: true
        },
        subheader: {
          fontSize: 12,
          bold: true,
          margin: [0, 10, 5, 5]
        },
        label: {
          bold: true,
          fontSize: 11
        },
        value: {
          fontSize: 11
        }
      }
    };

    pdfMake.createPdf(docDefinition).download(this.docName+'.pdf');
  }


  createFooterSection(data: { label: string, value: string }[], imageBase64: string) {
    return data.map(item => ({
      columns: [
        { text: `${item.label}:`, bold: true, width: 120, fontSize:11 },
        item.label === 'Signature' && imageBase64
          ? { image: imageBase64, width: 200, height: 100, margin: [-30, -5, 0, 0] }  // Show image for Signature
          : { text: item.value, width: '*',fontSize:11 }  // Show text for other labels
      ],
      margin: [0, 2, 0, 2]
    }));
  }
  createReasonSection(data: { label: string, value: string }[]) {
    return {
      stack: data.map(item => ({
        columns: [
          { text: `${item.label}:`, style: 'label', width: 120 },
          { text: item.value, style: 'value', width: 450 }
        ],
        margin: [0, 2, 0, 2]
      }))
    };
  }


  createSection(leftData: { label: string, value: string }[], rightData: { label: string, value: string }[]) {
    return {
      columns: [
        // Left Column Data
        {
          width: '50%',
          stack: leftData.map(item => ({
            columns: [
              { text: `${item.label}:`, style: 'label', width: 120 },
              { text: item.value, style: 'value', width: '*', color:'##212121' }
            ],
            margin: [0, 2, 0, 2]
          }))
        },
        // Right Column Data
        {
          width: '50%',
          stack: rightData.map(item => ({
            columns: [
              { text: `${item.label}:`, style: 'label', width: 120 },
              { text: item.value, style: 'value', width: '*', color: '##212121' }
            ],
            margin: [0, 2, 0, 2]
          }))
        }
      ]
    };
  }

  addReferral() {
   // console.log("isskipfalse ", this.isSkipfax);
    if (this.providerfax.length > 0) {
      this.isSkipfax = false;
    }
    if (this.ShowFax == true) {
      if (this.isSkipfax == false) {
        if (this.providerfax.length > 0 && this.isValidFax == true) {
          this._addReferral.fax = this.providerfax;        
          this.AddPatientReferral();
        } else {
          this.isFax = false;
        }
      } else {
        this.AddPatientReferral();
      }
    }else {
      this.AddPatientReferral();
    }
 
    console.log("provider fax number", this.providerfax)
  }


  validatePhone(phoneNumDigits: any) {
    let dummyPhone = phoneNumDigits.replace(/\D/g, '');
    phoneNumDigits = dummyPhone.replace(/\s/g, '');
    if (phoneNumDigits?.length == 0) {
      this.isFax = false;
    } else {
      this.isFax = true;
    }

    if (phoneNumDigits?.length == 0 || phoneNumDigits?.length == 14 || phoneNumDigits?.length == 10) {
      this.isValidFax = true;
    } else {
      this.isValidFax = false;
    }  
       
  }

  validatePhoneNo(field: any) {

    let phoneNumDigits = field.value.replace(/\D/g, '');
    field.value = phoneNumDigits;
    let isValidPhone = (phoneNumDigits?.length == 0 || phoneNumDigits?.length == 10);
    if (isValidPhone) {
      field.value = this.phrUtils.maskingPhoneNumer(phoneNumDigits);
    } else {
      field.value = phoneNumDigits;
    }
  }

  openAdvancedSearch() {
    console.log("Advanced Search Clicked");
    this.isAdvancedSearch ? this.isAdvancedSearch = false : this.isAdvancedSearch = true;
    if (this.isAdvancedSearch) {
      this.showSpecialists = false;
      // this.isSearch = true;
      this.results = [];
      this.results.length = 0;

    } else {
      this.nameNPIMissing = false;
      this.ptCity = '';
     // this.ptState = '';
      this.ptZip = '';
      this.speciality = '';
    }
    //console.log("state ",this.ptState);
  }



  selectProvider(provider: any, status: any) {
    this.status = status;
  //  console.log("provider ", provider);
  //  console.log("selected provider ", this.selectedProvider);
    if (provider == this.selectedProvider) {
      this.selectedProvider = '';
    } else {
      this.selectedProvider = provider;
    }
    //check is npi already in suggested
    
    if (status == 'search') {
      const isExist = this.referrals.find((npi: any) => npi.npi == provider.npi)
      console.log("is exist ", isExist);
      if (isExist) {
        status = 'suggested';
        provider = isExist;
      }
    }

    if (status == 'search') {
      this._addReferral.referraL_ID = this.referrals[0].referraL_ID;
      this._addReferral.npi = provider.number.toString();
      this._addReferral.firsT_NAME = provider.basic?.first_name;
      this._addReferral.lasT_NAME = provider.basic?.last_name;
      this._addReferral.speciality = provider.taxonomies[0]?.desc;
      this._addReferral.phonE_NO = provider.addresses[0]?.telephone_number;
      this._addReferral.email = '';
      this._addReferral.fax = provider.addresses[0]?.fax_number;
      this._addReferral.address = provider.addresses[0]?.address_1;
      this._addReferral.city = provider.addresses[0]?.city;
      this._addReferral.state = provider.addresses[0]?.state;
      this._addReferral.zip = provider.addresses[0]?.postal_code.substr(0, 5);
      this._addReferral.referraL_SENDING_METHOD = this.referrals[0].referraL_SENDING_METHOD;
      this._addReferral.senD_VIA_EMAIL = this.referrals[0].senD_VIA_EMAIL;
      this._addReferral.senD_VIA_SMS = this.referrals[0].senD_VIA_SMS;
      this._addReferral.direcT_ADDRESS = "";
      if (provider.enumeration_type == "NPI-1") {
        this._addReferral.iS_INDIVIDUAL_PROVIDER = '1';
      } else {
        this._addReferral.iS_INDIVIDUAL_PROVIDER ='0';
      }
    
      this._addReferral.alreadY_SUGGESTED = 'no'
      if (this._addReferral.phonE_NO == null) {
        this._addReferral.phonE_NO = '';
      } else if (this._addReferral.speciality == null) {
        this._addReferral.speciality = '';
      }
      const encryptedReferralRequest = this.phrUtils.encrypt(this._addReferral)
      localStorage.setItem("refRequest", encryptedReferralRequest)
    } else if (status == 'suggested') {
      console.log("suggested");
      this.selectedReferralProvider = provider as Referral;
    //  console.log("selected referral ", this.selectedReferralProvider);
      this._addReferral.alreadY_SUGGESTED = 'yes'
      this._addReferral.referraL_ID = this.selectedReferralProvider.referraL_ID;
      this._addReferral.npi = this.selectedReferralProvider.npi;
      this._addReferral.firsT_NAME = this.selectedReferralProvider.firsT_NAME;
      this._addReferral.lasT_NAME = this.selectedReferralProvider.lasT_NAME;
      this._addReferral.speciality = this.selectedReferralProvider.speciality;
      this._addReferral.phonE_NO = this.selectedReferralProvider.phonE_NO;
      this._addReferral.email = this.selectedReferralProvider.email;
      this._addReferral.fax = this.selectedReferralProvider.faX_NO;
      this._addReferral.address = this.selectedReferralProvider.address;
      this._addReferral.city = this.selectedReferralProvider.city;
      this._addReferral.state = this.selectedReferralProvider.state;
      this._addReferral.zip = this.selectedReferralProvider.zip;
      this._addReferral.referraL_SENDING_METHOD = this.selectedReferralProvider.referraL_SENDING_METHOD;
      this._addReferral.senD_VIA_EMAIL = this.selectedReferralProvider.senD_VIA_EMAIL;
      this._addReferral.senD_VIA_SMS = this.selectedReferralProvider.senD_VIA_SMS;
      this._addReferral.direcT_ADDRESS = "";
      const encryptedReferralRequest = this.phrUtils.encrypt(this._addReferral)
      const decryptedReferralRequest = this.phrUtils.decrypt(encryptedReferralRequest);
    //  console.log("decrypted value ", decryptedReferralRequest);
      localStorage.setItem("refRequest", encryptedReferralRequest)
    }
  }

  onClickBack() {
    this.mainScreen = false;
    this.confirmScreen = false;
    this.isreferralScreen = true;
    this.selectedProvider = '';
    localStorage.removeItem("refRequest");
  }

  toggleSpecialistList(): void {
    this.showSpecialists = !this.showSpecialists;
    if (this.showSpecialists) {
      this.isAdvancedSearch = false;
      this.searchStr = "";
      this.nameNPIMissing = false;
      this.results = [];
      this.noRecs = false;
    }

 

  }


  validateName(e: any) {
    let val = e.target.value.replace(/[^a-zA-Z]/g, "");
    e.target.value = val;
  }

  onlyCharAllow(event: any, type: any) {
    if (event.value.trim()) {
      let validname = event.value.replace(/[^a-zA-Z ]/g, "");
      event.value = validname;
    }
    else {
      event.value = event.value.trim();

    }
  }
  signatureImg: any;
  GetReferralDetails() {
    this.referralService.GetPatientReferralDetails(this.patientAccount, this.practiceCode, this.referrals[0].referraL_ID).subscribe((res: any) => {
      console.log("referral details");
      if (res) {
      //  console.log(res);
        this.ReferringDetails = res.data.referringPhysician;
        this.ReferralDetails = res.data.referralDetails;
      //  console.log(this.ReferringDetails);
     //   console.log(this.ReferralDetails);
        //exctract time only
        this.ReferralDetails.refStartDate = this.ReferralDetails.refStartDate.split(' ')[0];
        this.ReferralDetails.refEndDate = this.ReferralDetails.refEndDate.split(' ')[0];
        this.ReferralDetails.refDate = this.ReferralDetails.refDate.split(' ')[0];
        if (this.practiceCode == '1011163') {
          this.signatureImg = 'assets/images/signature.png';
        } else {
          if (this.ReferralDetails.signature) {
            this.signatureImg = "assets/" + this.ReferralDetails.signature;
          }
        }
       
        console.log("signature img ", this.signatureImg);
        
        //mask phonenumber
        this.ReferringDetails.phoneNumber = this.maskPhoneNumber(this.ReferringDetails.phoneNumber);
        this.ReferringDetails.fax = this.maskPhoneNumber(this.ReferringDetails.fax);

        //mask zip code
        this.ReferringDetails.zipCode = this.phrUtils.maskingZipNum(this.ReferringDetails.zipCode);

        //name to in titlecase
        this.ReferringDetails.name = this.toTitleCase(this.ReferringDetails.name);
        this.ReferralDetails.signedBy = this.toTitleCase(this.ReferralDetails.signedBy);
        this.ReferringDetails.address = this.toTitleCase(this.ReferringDetails.address);
        this.ReferringDetails.city = this.toTitleCase(this.ReferringDetails.city);

        
       // let str = "E13.51-Other specified diabetes mellitus with diabetic peripheral angiopathy without gangrene, diabetes mellitus with diabetic amyotrophy, E13.44-Other specified diabetes mellitus with diabetic amyotrophy, I15.2-Hypertension secondary to endocrine disorders, E08.44-Diabetes mellitus due to underlying condition with diabetic amyotrophy, J01.80-Other acute sinusitis";
        let str = this.ReferralDetails.diagnosis;
        console.log("string length ", str.length);
        if (str !="") {
          // Split the string into an array
          let valuesArray = str.split(',');

          // Use a Set to remove duplicates
          let uniqueValuesArray = Array.from(new Set(valuesArray));

          // Join the array back into a string with a comma followed by a space
          let uniqueStrWithSpace = uniqueValuesArray.join(', ');

       //   console.log("diagnosis ",uniqueStrWithSpace);
          this.ReferralDetails.diagnosis = uniqueStrWithSpace;
        }
   


      }
    }, (error:any)=> {
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
    })
  }

  searchProvider() {
    console.log("search")
    if (this.searchStr.length == 0) {
      this.selectedProvider = '';
      this.results = [];
    }
    if (this.isAdvancedSearch == false && this.searchStr.length >= 3) {
      this.searchReferralProvider();
    } else {
      if (this.searchStr.length > 0) {
        this.selectedProvider = '';
        this.showSpecialists = false;
        this.isSearch = true;
        this.nameNPIMissing = false;
      }
      return;
    }
  }

  // search care team
  noRecs: boolean = false;
  searchingSpecialist: boolean = false;
  _searchedCareTeam: modelCareTeam[] = [];
  searchStr: string="";
  results: Results[] = [];
  resultss: npiSearchResponse[] = [];
  dNone: boolean = true;
  selectedproviderAddres:any
  selectedproviderCity:any
  selectedproviderState:any
  selectedproviderZip:any
  selectedproviderPhone:any
  searchReferralProvider() {
    // this.searchStr = event.target.value;
    //if (this.isAdvancedSearch==false) {
    //  this.city = '';
    //  this.state = '';
    //  this.zip = '';
    //}
  
    if (this.searchStr.length > 0) {
      this.selectedProvider = '';
      this.showSpecialists = false;
      this.isSearch = true;
      this.nameNPIMissing = false;
    }
    this.dNone = this.searchStr.length >= 3 ? false : true;
    /*
    if (this.searchStr == "") {
      this.searchingSpecialist = false;
      this.results = [];
      this.results.length = 0;
      this.noRecs = false;
      this.isAdvancedSearch ? this.nameNPIMissing = true : this.nameNPIMissing = false;
      console.log("name or npi is missing");
      return;
    }
    */
    
    let dto = {
      PatientAccount: this.patientAccount,
      Number: "",
      FirstName: "",
      LastName: "",
      Zip: "",
      State: "",
      City: "",
      TaxonomyDescription: this.speciality,

    }
    if (this.ptZip != '') {
      dto.Zip = this.ptZip;
    } else {
      dto.Zip = '';
    }
    if (this.ptCity != '') {
      dto.City = this.ptCity;
    } else {
      dto.City = '';
    }
    if (this.ptState != '') {
      dto.State = this.ptState;
    } else {
      dto.State = '';

    }

    if (this.searchStr.trim().length == 10 && !this.searchStr.trim().includes(' ') && Number(this.searchStr)) {
      dto.FirstName = "";
      dto.LastName = "";
      dto.Number = this.searchStr.trim();
      dto.City = "";
      dto.State = "";
      dto.Zip = "";
    }
    else {
      let name = this.searchStr.trim();
      let fullName = name.trim().split(' ');
      dto.FirstName = fullName[0];
      if (fullName.length > 1) {
        dto.LastName = fullName[1];
      }
    }

    this.searchingSpecialist = true;
    this.results = [];

    this.referralService.searchProviderByNPI(dto).subscribe((res: any) => {
      if (res.data.results) {
        this.results = res.data.results as Results[];
        this.results = this.results.filter(val => !(val.basic.first_name == null && val.basic.last_name == null));

        this.results = this.results.filter((value, index, self) => {
          // Check if the NPI number and other contcat info already exists in the filtered array
          return self.findIndex((t) => t.number === value.number || (t.addresses[0].telephone_number === value.addresses[0].telephone_number && t.addresses[0].fax_number === value.addresses[0].fax_number && t.taxonomies[0]?.desc === value.taxonomies[0]?.desc)) === index;
        });

        this.results.forEach((val, index) => {
          val.addresses[0].postal_code = this.phrUtils.maskingZipNum(val.addresses[0].postal_code);
          if (val.addresses[0].telephone_number != null) {
            const cleanedPhoneNumber = val.addresses[0].telephone_number.replace(/[^0-9]/g, '');
            val.addresses[0].telephone_number = this.phrUtils.maskingPhoneNumer(cleanedPhoneNumber);
          } else {
            val.addresses[0].telephone_number = '';
          }
          if (val.addresses[0].fax_number != null) {
            const cleanedFaxNumber = val.addresses[0].fax_number.replace(/[^0-9]/g, '');
            val.addresses[0].fax_number = this.phrUtils.maskingPhoneNumer(cleanedFaxNumber);
          } else {
            val.addresses[0].fax_number = '';
          }



        });
        if (this.results.length == 0) {
          this.noRecs = true;
        }
        else {
          this.noRecs = false;
          this.isAdvancedSearch = false;
        }
        this.searchingSpecialist = false;
        console.log(this.searchingSpecialist);
      } else {
        if (res.data.results ==null) {
          this.noRecs = true;
          this.searchingSpecialist = false;
          this.results = [];
        }
      }
    },
      (error: any) => {
        this.searchingSpecialist = false;
        this.noRecs = true;
        this.results = [];
      });
  }

  closetab() {
    //window.close();
    let query = sessionStorage.getItem('referralLink');

    if (query == null) {
      query = '';
    }
    this.router.navigateByUrl("preferral?ref=" + query);
  }

  ObjProvider: any = {};
  searchReferralProviderr() {
    if (this.searchStr.length > 0) {
      this.selectedProvider = '';
      this.showSpecialists = false;
      this.isSearch = true;
      this.nameNPIMissing = false;
    }
   
    this.dNone = this.searchStr.length >= 3 ? false : true;
    /*
    if (this.searchStr == "") {
      this.searchingSpecialist = false;
      this.results = [];
      this.results.length = 0;
      this.noRecs = false;
      //this.isAdvancedSearch ? this.nameNPIMissing = true : this.nameNPIMissing = false;
      console.log("name or npi is missing");
      return;
    }*/

      if (this.searchStr.trim().length == 10 && !this.searchStr.trim().includes(' ') && Number(this.searchStr)) {
        this.ObjProvider['providerFirstName'] = '';
        this.ObjProvider['providerLastName'] = '';
        this.ObjProvider['npi'] = this.searchStr.trim();
     
      }
      else {
        let name = this.searchStr.trim();
        let fullName = name.trim().split(' ');
        this.ObjProvider['providerFirstName'] = fullName[0];
        this.ObjProvider['providerLastName'] = "";
        if (fullName.length > 1) {
          this.ObjProvider['providerLastName'] = fullName[1];
        }
        this.ObjProvider['npi'] = "-1";
      }
      this.searchingSpecialist = true;
      this.results = [];

      this.ObjProvider['patientAccount'] = this.patientAccount;
    this.ObjProvider['taxonomyDescription'] = this.speciality;
    this.ObjProvider['entityTypeCode'] = '-1';
    if (this.ptZip != '') {
      this.ObjProvider['zipCode'] = this.ptZip;
    } else {
      this.ObjProvider['zipCode'] = this.defaultptZip;
    }
    if (this.ptCity != '') {
      this.ObjProvider['city'] = this.ptCity;
    } else {
      this.ObjProvider['city'] = '';
    }
    if (this.ptState != '') {
      this.ObjProvider['state'] = this.ptState;
    } else {
      this.ObjProvider['state'] = '';

    }
    this.ObjProvider['nearByZipCodes'] = "";
    this.ObjProvider['radius'] = '10';
    this.ObjProvider['origin'] = this.patientAddress + ', ' + this.defaultptCity + ', ' + this.defaultptState + ' ' + this.defaultptZip + 'USA';
   // console.log(this.patientAddress + ', ' + this.defaultptCity + ', ' + this.defaultptState + ' ' + this.defaultptZip + ', ' +'USA');

      this.referralService.ProviderSearch(this.ObjProvider).subscribe((res: any) => {
        if (res) {
          this.resultss = res.data.getProviders as npiSearchResponse[];
         // console.log(this.results);
          this.resultss = this.resultss.filter((value, index, self) => {
            // Check if the NPI number already exists in the filtered array
            return self.findIndex((t) => t.npi === value.npi) === index;
          });

          this.resultss.forEach((val:any) => {
            if (val.provider_Business_Practice_Location_Address_Telephone_Number != null) {
              const cleanedPhoneNumber = val.provider_Business_Practice_Location_Address_Telephone_Number.replace(/[^0-9]/g, '');
              val.provider_Business_Practice_Location_Address_Telephone_Number = this.phrUtils.maskingPhoneNumer(cleanedPhoneNumber);
            }
            else {
              val.provider_Business_Practice_Location_Address_Telephone_Number = '';
            }

            if (val.provider_Business_Practice_Location_Address_Fax_Number != null) {
              const cleanedPhoneNumber = val.provider_Business_Practice_Location_Address_Fax_Number.replace(/[^0-9]/g, '');
              val.provider_Business_Practice_Location_Address_Fax_Number = this.phrUtils.maskingPhoneNumer(cleanedPhoneNumber);
            }
            else {
              val.provider_Business_Practice_Location_Address_Fax_Number = '';
            }

            if (val.provider_Last_Name == "" && val.provider_First_Name == "" && val.enumeration_type=="2") {
              val.provider_First_Name = val.provider_Organization_Name.replace(/\"/g, '');
            }

          });

          if (this.resultss.length == 0) {
            this.noRecs = true;
          }
          else {
            this.noRecs = false;
            this.isAdvancedSearch = false;
          }
          this.searchingSpecialist = false;
        }
      },
        (error: any) => {
          this.searchingSpecialist = false;
          this.noRecs = true;
          this.resultss = [];
        })
    
  }

  
  specialityList: any = [];
  filteredspeciality: any = [];
  GetSpecialityList() {
    this.referralService.GetAllSpeciality(this.patientAccount, this.practiceCode).subscribe((res: any) => {
      if (res.data) {

        this.specialityList = res.data.getSpecialities;

        this.specialityList = this.specialityList.filter((value:any, index:any, self:any) => {
          // Check if the description already exists in the filtered array
          return self.findIndex((t: any) => t.description === value.description) === index;
        });

        this.filteredspeciality = this.specialityList;

      } else {
        console.log("no speciality found");
        //let text = "Service is not available, please try later.";
        //this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        //  text = translation;
        //});
        //this.phrUtils.showError(text);
      }
    }, (error: any) => {
      console.log("error occour speciality not found");
    //  let text = "Service is not available, please try later.";
    //  this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
    //    text = translation;
    //  });
    //  this.phrUtils.showError(text);
    })
  }

  PatientSpecialitySearch(event:any) {
    const str = event.target.value.toLowerCase();
    //console.log(str);
    this.filteredspeciality = this.specialityList;
    this.filteredspeciality = this.filteredspeciality.filter((option: any) => option.description.toLowerCase().includes(str));
    //console.log(this.filteredspeciality);
    if (str == '') {
      this.filteredspeciality = this.specialityList;
    }
  }

  SetSpecialitySearch(spec: any) {
    this.speciality = spec;
  }

  onFocusOutZIPFinancial(data: any,type:any) {


    let zipcode;
    if (type == 1) {
      if (data) {
        zipcode = data.replace(/\D/g, '');
        zipcode = this.phrUtils.maskingZipNum(zipcode);
        this.ptZip = zipcode;
      } else {
        zipcode = "";
      }
    } else {
      let phoneNumDigits;
      if (data) {
        phoneNumDigits = data.value.replace(/\D/g, '');
        phoneNumDigits = this.phrUtils.maskingZipNum(phoneNumDigits);
        data.value = phoneNumDigits;
        zipcode = data.value;
        this.ptZip = zipcode;
      } else {
        zipcode = "";
        phoneNumDigits = "";
      }
    }

    zipcode = zipcode.replace(/\D/g, '');
    if (zipcode && (zipcode?.length == 5 || zipcode?.length == 9)) {
      this.spinner.show();
      // this.CityandStateRequest.ZIP_CODE = zipcode;
      this.UpdateinfoService.getZipCityState(zipcode, this.patientAccount, this.practiceCode).subscribe((res: any) => {
        this.spinner.hide();
        if (res.data && res.data?.length > 0) {
          this.isZipCodeNotValidFinancialInfo = false;
          //this.isZipCode = false;
          this._cityandstate = res.data;
      
          if (type == 0) {
            this.ptCity = this._cityandstate[0].cityName;
            this.ptState = this._cityandstate[0].stateCode;
          } else
            if (type == 1) {
              this._cityandstate?.map((res: any) => {
                if (res.cityName.toLowerCase().trim() == this.ptCity.toLowerCase().trim())
                  this.ptCity = res.cityName.trim();
                if (res.stateCode.toLowerCase().trim() == this.ptState.toLowerCase().trim())
                  this.ptState = res.stateCode.trim();

              });

            }
        } else {
          this.ptCity = "";
          this.ptState = "";
          this.isZipCodeNotValidFinancialInfo = true;
        }
      },
        (error: any) => {
          this.isZipCodeNotValidFinancialInfo = true;
          this.ptCity = "";
          this.ptState = "";
          this.spinner.hide();
        })
    }
    else {
      this.ptCity = "";
      this.ptState = "";
      this._cityandstate = [];
    }
  }
  phoneLink: any;
  GetPatientSelectedReferral(patientAccount: any, practiceCode: any) {
    this.spinner.show();
    this.referralService.GetPatientSelectedReferral(patientAccount, practiceCode, this.referrals[0].referraL_ID).subscribe((res: any) => {

      this.spinner.hide();
      //console.log("result ", res);
      if (res.statusCode == 200) {
        this.getSelectedReferralInfo = res.data.selectedReferrals as selectedReferrals[];
        if (this.getSelectedReferralInfo.length>0) {
          this.mainScreen = true;
          this.confirmScreen = false;
          this.isreferralScreen = false;
          this.getSelectedReferralInfo[0].phonE_NO = this.maskPhoneNumber(this.getSelectedReferralInfo[0].phonE_NO);
          this.getSelectedReferralInfo[0].faX_NO = this.maskPhoneNumber(this.getSelectedReferralInfo[0].faX_NO);
          this.getSelectedReferralInfo[0].zip = this.phrUtils.maskingZipNum(this.getSelectedReferralInfo[0].zip);
          this.getSelectedReferralInfo[0].referral_FirstName = this.toTitleCase(this.getSelectedReferralInfo[0].referral_FirstName);
          this.getSelectedReferralInfo[0].referral_LastName = this.toTitleCase(this.getSelectedReferralInfo[0].referral_LastName);
          this.getSelectedReferralInfo[0].city = this.toTitleCase(this.getSelectedReferralInfo[0].city);
          this.getSelectedReferralInfo[0].address = this.toTitleCase(this.getSelectedReferralInfo[0].address);
          if (this.getSelectedReferralInfo[0].phonE_NO) {
            this.phoneLink = "tel:+1" + this.getSelectedReferralInfo[0].phonE_NO;
          }
         
        }
        // we need to show fax filed in case of missing fax number
       // console.log("selected referral ", this.getSelectedReferralInfo);
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      }

    },
      (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      })
  }
  confirmReferral() {
   // console.log("referral fax ", this._addReferral.fax);
    if (this._addReferral.fax != '') {
      this._addReferral.fax = this.maskPhoneNumber(this._addReferral.fax);
      this.ShowFax = false;
    } else {
      this.providerfax = '';
      this.ShowFax = true;
    }
    this.mainScreen = false;
    this.confirmScreen = true;
    this.isreferralScreen = false;
    //$("#confirmReferralmodel").modal("show");
  }
  showReferralInfoPopup() {
    $('#referralinfo-modal').modal('show');
  }

  AddPatientReferral() {

    this._addReferral.patienT_ACCOUNT = this.patientAccount;
    this._addReferral.practicE_CODE = this.practiceCode;
    this._addReferral.confirmeD_BY_PATIENT = '1';
    this._addReferral.useR_NAME = this.patientFname + '' + this.patientLname;
    this._addReferral.phonE_NO = this.unMaskPhoneNumber(this._addReferral.phonE_NO);
    this._addReferral.fax = this.unMaskPhoneNumber(this._addReferral.fax);

   // console.log("ReferralObj ", this._addReferral);
   // return;
    this.spinner.show();
    this.referralService.AddPatientReferral(this._addReferral).subscribe((res: any) => {

      this.spinner.hide();
     // console.log("result ", res);
      if (res.statusCode == '200') {
        console.log("record saved");
        this.phrUtils.showSuccess("Referral physician confirmed successfully");
        localStorage.removeItem("refRequest");
        this.GetPatientSelectedReferral(this.patientAccount, this.practiceCode);

        this.selectedProvider = '';
      } else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      }

    },
      (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      })
  }
  //maintain logs
  printReferralLogs(patientAccount:any, practiceCode:any) {
    this.referralService.printReferralLog(patientAccount, practiceCode,).subscribe((res: any) => {
      console.log(res);
    }, (error: any) => {
      console.log("unable to send logs");
    })
  }
}

